<template>
    <div class="animated fadeIn">
        <DynamicList
                ref="dynamicCardList"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                :onRetrieve="onRetrieve"
                root="/report/commerce-sales20192020"
                :searchArgs="searchArgs">

            <slot slot="afterList">
                <div v-if="dataCharts !== false" class="card-group mb-3 animated fadeIn">
                    <div class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{dataCharts.count}}</div>
                            <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Nombre de participants")}}</small>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{Core.Currency.format(dataCharts.subTotal)}}</div>
                            <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Sous-Total")}}</small>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{Core.Currency.format(dataCharts.deduction)}}</div>
                            <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Déduction")}}</small>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{Core.Currency.format(dataCharts.total)}}</div>
                            <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Total")}}</small>
                        </div>
                    </div>
                </div>

                <div v-if="dataCharts !== false && !Core.Session.AuthUser.can('league_manager')"  class="card-group mb-3 animated fadeIn">
                    <div v-for="league in dataCharts.leagues" class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{Core.Currency.format(league.total)}}</div>
                            <small class="text-muted text-uppercase font-weight-bold">{{league.label}}</small>
                        </div>
                    </div>
                </div>

                <div v-if="dataCharts !== false" class="card-group mb-3 animated fadeIn">
                    <div class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{Core.Definition.getDefinition("Saisons")}}</div>
                            <small class="text-muted text-uppercase font-weight-bold"></small>

                            <ChartPie
                                    :labels="dataCharts.pie.season.labels"
                                    :sets="[
                                          {
                                             label: Core.Definition.getDefinition('Saisons'),
                                             backgroundColor: dataCharts.pie.season.backgroundColors,
                                             data: dataCharts.pie.season.datas
                                         }]"
                            >
                            </ChartPie>

                        </div>
                    </div>
                    <div v-if="!Core.Session.AuthUser.can('league_manager')" class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{Core.Definition.getDefinition("Ligues")}}</div>
                            <small class="text-muted text-uppercase font-weight-bold"></small>

                            <ChartPie
                                    :labels="dataCharts.pie.league.labels"
                                    :sets="[
                                        {
                                            label: Core.Definition.getDefinition('Ligues'),
                                            backgroundColor: dataCharts.pie.league.backgroundColors,
                                            data: dataCharts.pie.league.datas
                                        }]"
                            >
                            </ChartPie>

                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{Core.Definition.getDefinition("Catégories")}}</div>
                            <small class="text-muted text-uppercase font-weight-bold"></small>

                            <ChartPie
                                    :labels="dataCharts.pie.category.labels"
                                    :sets="[
                                        {
                                            label: Core.Definition.getDefinition('Catégories'),
                                            backgroundColor: dataCharts.pie.category.backgroundColors,
                                            data: dataCharts.pie.category.datas
                                        }]">
                            </ChartPie>
                        </div>
                    </div>
                </div>
            </slot>

            <slot slot="afterSearchForm">
                <b-button @click="$refs.modalExport.open = true" variant="light" class="mb-3">
                    {{Core.Definition.getDefinition("Exporter sous format ...")}}
                </b-button>
                <ModalExport
                        ref="modalExport"
                        root="/report/commerce-sales20192020"
                        :formStructure="{
                                rows: [
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportFormat'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                     {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportTitle'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'firstname'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'lastname'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'eventProductTitle'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'ticketNumber'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                     {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'teamTitle'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'participantCategoryTitle'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'tShirtSize'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'tShirtCustomName'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'leagueTitle'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'regularPrice'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'promocode'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'email'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                ],
                                fields: [
                                    {
                                        id: 'exportFormat',
                                        type: 'select',
                                        options: Core.Export.formatOptions(),
                                        label: Core.Definition.getDefinition('Format'),
                                        value: null,
                                        onSelect: function() {}
                                    },
                                    {
                                        id: 'exportTitle',
                                        type: 'text',
                                        label: Core.Definition.getDefinition('Titre'),
                                        value: '',
                                        required: true
                                    },
                                    {
                                        id: 'eventProductTitle',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Produit'),
                                        value: true,
                                        export: 'eventProductTitle',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'firstname',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Prénom'),
                                        value: true,
                                         export: 'firstname',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'lastname',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Nom de famille'),
                                        value: true,
                                         export: 'lastname',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'ticketNumber',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Numéro de billet'),
                                        value: true,
                                         export: 'ticketNumber',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'teamTitle',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Équipe'),
                                        value: true,
                                         export: 'teamTitle',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'participantCategoryTitle',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Catégorie'),
                                        value: true,
                                         export: 'participantCategoryTitle',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'tShirtSize',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Taille t-shirt'),
                                        value: true,
                                         export: 'tShirtSize',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'tShirtCustomName',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Nom personnalisé t-shirt'),
                                        value: true,
                                         export: 'tShirtCustomName',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'leagueTitle',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Ligue'),
                                        value: true,
                                         export: 'leagueTitle',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'regularPrice',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Prix régulier'),
                                        value: true,
                                         export: 'regularPrice',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'promocode',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Code promo'),
                                        value: true,
                                         export: 'promocode',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'email',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Courriel'),
                                        value: true,
                                         export: 'email',
                                        onChange: function() {}
                                    },
                                ]}"
                @onSubmit="onExport">
                </ModalExport>
            </slot>
        </DynamicList>
    </div>
</template>

<script>
    import DynamicList from '../../../../components/DynamicList'
    import ModalExport from '../../../../components/ModalExport'
    import ChartPie from '../../../../components/ChartPie'
    export default {
        name: 'ReportCommerceTicket',
        components: {
            DynamicList,
            ModalExport,
            ChartPie
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataSearchArgs: [],
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('Billet'),
                        key: 'ticketNumber',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Prénom'),
                        key: 'firstname',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Nom'),
                        key: 'lastname',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Courriel'),
                        key: 'email',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Équipe'),
                        key: 'teamTitle',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Catégorie'),
                        key: 'participantCategoryTitle',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('T-Shirt'),
                        key: 'tShirtSize',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Nom perso.'),
                        key: 'tShirtCustomName',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Produit'),
                        key: 'eventProductTitle',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Ligue'),
                        key: 'leagueTitle',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Événement'),
                        key: 'eventTitle',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Prix régulier'),
                        key: 'regularPrice',
                        sortable: false,
                        type: 'currency'
                    },
                    {
                        label: Core.Definition.getDefinition('Code promo'),
                        key: 'promocode',
                        sortable: false,
                        type: 'text'
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'ticketNumber'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'start'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'end'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'purchaseId'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'firstname'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'lastname'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'teamId'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'categoryId'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'leagueId'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'email'
                                        }
                                    ]
                                },
                                {},
                                {}
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'email',
                            type: 'text',
                            label: Core.Definition.getDefinition('Courriel'),
                        },
                        {
                            id: 'start',
                            type: 'date',
                            label: Core.Definition.getDefinition('Début'),
                        },
                        {
                            id: 'end',
                            type: 'date',
                            label: Core.Definition.getDefinition('Fin'),
                        },
                        {
                            id: 'ticketNumber',
                            type: 'text',
                            label: Core.Definition.getDefinition('# billet'),
                        },
                        {
                            id: 'firstname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Prénom'),
                            value: ''
                        },
                        {
                            id: 'lastname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Nom de famille'),
                            value: ''
                        },
                        {
                            id: 'purchaseId',
                            type: 'text',
                            label: Core.Definition.getDefinition('ID achat'),
                            value: ''
                        },
                        {
                            id: 'productId',
                            type: 'select',
                            label: Core.Definition.getDefinition('Produit'),
                            value: null,
                            onSelect: function() {
                            }
                        },
                        {
                            id: 'categoryId',
                            type: 'select',
                            label: Core.Definition.getDefinition('Catégorie'),
                            value: null,
                            onSelect: function() {
                            }
                        },
                        {
                            id: 'teamId',
                            type: 'select',
                            label: Core.Definition.getDefinition('Équipe'),
                            value: null,
                            onSelect: function() {
                            }
                        },
                        {
                            id: 'leagueId',
                            type: 'select',
                            isVisible: Core.Session.AuthUser.can('report_multiple_league'),
                            label: Core.Definition.getDefinition('Ligue'),
                            value: null,
                            onSelect: function() {
                            }
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataCharts: false,
                dataSelectOptions: {}
            }
        },
        methods: {
            onExport() {
                let searchArgs = this.$refs.dynamicCardList.$refs.request.dataArgs
                for(let searchArg in searchArgs) {
                    searchArg = searchArgs[searchArg]
                    this.$refs.modalExport.$refs.request.addArg(searchArg.key, searchArg.value, searchArg.type)
                }
            },
            onRetrieve(data) {
              if(data !== undefined) {
                  if (data.charts !== undefined) {
                      this.dataCharts = data.charts
                  }
                  if (data.selectOptions !== undefined) {
                      this.dataSelectOptions = data.selectOptions
                  }
              }
            },
            clickEdit(value, cell, row) {
                this.$router.push('/commerce/commandes/' + row.purchaseId)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
